module.exports = __webpack_public_path__ + "static/media/zeewoldeactueel.5ec0a0e2.png";